export const TRY_LATER = 'Ocorreu um erro, tente mais tarde';

export const ERROR_MESSAGE = {
  TRY_LATER,
};
